module.exports = __webpack_public_path__ + "static/img/img_media05.ea66326.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partners_pc/img_media05.png
// module id = jHkA
// module chunks = 0